import { Mail, Person } from "@material-ui/icons";
import { FaFacebook, FaGithub, FaLinkedin } from "react-icons/fa";
import "./topbar.scss";

export default function Topbar({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar " + (menuOpen && "active")}>
      <div className="wrapper">
        <div className="left">
          <img src="assets/logo.png" width={50}></img>
          <a href="#intro" className="logo">
            Coder.h
          </a>
          <div className="itemContainer">
            <Person className="icon" />
            <span>+8801910298191</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <span>abhichy30@gmail.com</span>
          </div>
          <div className="itemContainer ">
            <a
              className="links"
              href="https://www.facebook.com/scientistavijit64/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebook size="2rem" />
            </a>
            <a
              className="links"
              href="https://www.linkedin.com/in/avijitchy/"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub size="2rem" />
            </a>

            <a
              className="links"
              href="https://github.com/AvijitChowdhury"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin size="2rem" />
            </a>
          </div>
        </div>
        <div className="right">
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
